<template>
  <div id="statistic">
    <div class="ipub-filter-div mar-b-20">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="2">
            <!-- <ipub-select v-model="nameList"
                         placeholder="ALL"
                         @change="changeState">
              <ipub-select-option v-for="(item,index) in journalList"
                                  :key="'editorList'+item.id"
                                  :value="item.name">
              </ipub-select-option>
            </ipub-select> -->
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal"
                         :options="journalList" />
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.keyword"
                               placeholder="Search for title or location"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">Start Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'StartTime')}"
                                      v-model="startDate" />
            </ipub-col>
            <ipub-col :span="6"
                      class="flex"
                      style="align-item:centen">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">End Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'EndTime')}"
                                      v-model="endDate" />
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div>
      <div class="ipub-p1 mar-b-20 relative">
        update time: {{$moment(staticTime).format('HH : mm DD / MM / YYYY')}}
        <div class="right-option">
          <ipub-button :loading="loading"
                       type="primary"
                       @click="exp">
            Export
          </ipub-button>
        </div>
      </div>
      <ipub-table :columns="columns"
                  @order="onOrderChanage"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:title="{ text, record }">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft">
            <div slot="title">
              {{text}}
            </div>
            <div class="omis link-color ipub-c-p"
                 @click="detail(record)">
              {{text}}
            </div>
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <!-- <add-conferences ref="conferences-form"
                     :isVisable="isVisable"
                     @confirm="confirm"
                     @cancel="cancel"></add-conferences> -->
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
